<template>
  <td
    class="m-table-cell m-table-cell-spacer"
    :class="{
      'm-table-cell-container_right-border': hasRightBorder,
      'm-table-cell-container_column-sticked': isColumnSticked,
      'm-table-cell-container_sticky-column': sticky,
    }"
    :style="cssVars"
  />
</template>

<script>
  import getCssVarNameForColumn from 'components/Data/Tables/MTable/utils/getCssVarNameForColumn';

  export default {
    name: 'MTableCellSpacer',
    props: {
      hasRightBorder: {
        type: Boolean,
        default: false
      },
      itemKey: {
        type: String,
        default: ''
      },

      // is cell Sticky, enables position: sticky
      sticky: Boolean,
      stickyOffset: {
        type: Object,
        default: Object
      },
      stickedColumns: {
        type: Object,
        default: Object
      }
    },
    computed: {
      isColumnSticked () {
        return this.sticky && this.stickedColumns[this.itemKey];
      },
      stickyLeftOffset () {
        return this.stickyOffset[this.itemKey];
      },
      cssVars () {
        return {
          '--sticky-left-offset': this.stickyLeftOffset,
          '--current-cell-width': `var(${getCssVarNameForColumn(this.itemKey, 'width')})`
        };
      }
    }
  };
</script>

<style>
  .m-table-cell-spacer {
    background: var(--background-color);
  }

  .m-table__body td.m-table-cell-spacer {
    height: 8px;
  }

  .m-table-cell.m-table-cell-spacer {
    display: table-cell;
    padding: 0;
  }
</style>
